module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 160.53e986ad.png";